import type { Country } from '@kitopi-com/customer-auth';

/** Every market Kitopi operates in has its own IANA time zone, so the zone identifies the country. */
const TIME_ZONE_TO_COUNTRY: Record<string, Country> = {
  'Asia/Dubai': 'AE',
  'Asia/Riyadh': 'SA',
  'Asia/Kuwait': 'KW',
  'Asia/Qatar': 'QA',
  'Asia/Bahrain': 'BH',
  'Asia/Muscat': 'OM',
  'Europe/Warsaw': 'PL',
};

const getBrowserTimeZone = (): string | undefined => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

export const getCountryFromTimeZone = (
  timeZone: string | undefined = getBrowserTimeZone()
): Country | undefined => (timeZone ? TIME_ZONE_TO_COUNTRY[timeZone] : undefined);
